import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=7eae9e17&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eae9e17')) {
      api.createRecord('7eae9e17', component.options)
    } else {
      api.reload('7eae9e17', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=7eae9e17&", function () {
      api.rerender('7eae9e17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrP4BZsZwhER/JS/comp/childrenage.vue"
export default component.exports